/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ solution: NonNullable<unknown> }} Task_Complete_Note_RequiredInputs */

const en_task_complete_note_required = /** @type {(inputs: Task_Complete_Note_RequiredInputs) => LocalizedString} */ (i) => {
	if (i?.solution === "accepted_will_pay") return /** @type {LocalizedString} */ (`Enter the agreed payment method and the third party's details to complete this task.`);
	return /** @type {LocalizedString} */ (`Add a justification note to complete this task.`)
	
};

const pt_br2_task_complete_note_required = /** @type {(inputs: Task_Complete_Note_RequiredInputs) => LocalizedString} */ (i) => {
	if (i?.solution === "accepted_will_pay") return /** @type {LocalizedString} */ (`Informe a forma de pagamento combinada e os dados do terceiro para concluir esta tarefa.`);
	return /** @type {LocalizedString} */ (`Adicione uma justificativa para concluir esta tarefa.`)
	
};

/**
* | solution | output |
* | --- | --- |
* | "accepted_will_pay" | "Enter the agreed payment method and the third party's details to complete this task." |
* | * | "Add a justification note to complete this task." |
*
* @param {Task_Complete_Note_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_complete_note_required = /** @type {((inputs: Task_Complete_Note_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Complete_Note_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_complete_note_required(inputs)
	return pt_br2_task_complete_note_required(inputs)
});